// Typelizer digest 59993c93b98f02ef0268028584bffee1
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** GET /accountant/profile */
  show: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/accountant/profile', {}, options),
    method: 'get',
  }),
}
